import styled from "styled-components";

export const OnlineFormRequestEditFormStyled = styled.div`
  width: 100%;
  .row {
    display: flex;
    column-gap: 1rem;
    .input_wrap {
      flex: 1;
    }
    .btn_wrap {
      flex-basis: 167px;
    }
  }
`;
